import { useLayoutEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import { THeartRate } from "../../../@types";
import { calculateWind, normalizeGpsData } from "../../../utils";
import { TLocation } from "../Student/FlightLogs/FlightLogs";
import { ThreeDMapCesium } from "./ThreeDMapCesium";
import {
	notifyNativeThreeDMapError,
	notifyNativeThreeDMapReady,
	parseNativePayload,
} from "./threeDMapBridge";

import "./three_d_map.scss";

export function ThreeDMap() {
	const [searchParams] = useSearchParams();
	type TState = {
		gpsData: TLocation[];
		heartRates: THeartRate[] | null;
	};
	const [state, setState] = useState<TState>({
		gpsData: [],
		heartRates: null,
	});

	const colorScheme = searchParams.get("color");

	useLayoutEffect(() => {
		const handleMessage = (event: any) => {
			try {
				let data: TLocation[] = normalizeGpsData(
					parseNativePayload<TLocation[]>(event.detail.gpsData, []),
				);
				if (data.length < 2) {
					throw new Error(
						"Flight path requires at least two moving GPS points",
					);
				}

				let metarWind: { speed: number; direction: number } | null = null;
				const weather = parseNativePayload<{
					wind: {
						speed: { value: number; unit: string };
						direction: { value: number; unit: string };
					};
				} | null>(event.detail.weather, null);
				if (weather?.wind) {
					metarWind = {
						speed: weather.wind.speed.value,
						direction: weather.wind.direction.value,
					};
				}
				const heartRates = parseNativePayload<THeartRate[] | null>(
					event.detail.heartRates,
					null,
				);
				data = calculateWind(data, metarWind).enhancedGPSData as TLocation[];
				setState((prevState) => ({
					...prevState,
					gpsData: data,
					heartRates,
				}));
			} catch (error) {
				notifyNativeThreeDMapError(error);
			}
		};
		window.addEventListener("receivegpsdata", handleMessage);
		notifyNativeThreeDMapReady();

		return () => {
			window.removeEventListener("receivegpsdata", handleMessage);
		};
	}, [colorScheme]);

	if (state.gpsData.length === 0) {
		return null;
	}

	return (
		<ThreeDMapCesium gpsData={state.gpsData} heartRates={state.heartRates} />
	);
}
